<template>
    <v-dialog
            v-model="dialog"
            width="500">

        <v-card>
            <v-card-title
                    primary-title>
                <v-icon left>mdi-key</v-icon>
                {{ dialogTitle }}
            </v-card-title>

            <v-card-text style="padding-top: 20px;">
                <!--{{ deleteText }}-->

                <div v-if="logged_user">
                    <v-text-field  v-model="password" outlined label="Unesite novu lozinku" @click:append="show1 = !show1" hide-details :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'"></v-text-field>
                    <!--<div v-if="password">-->
                        <!--<span class="font-weight-grey">Nova lozinka: </span>-->
                        <!--<span class="font-weight-bold">{{password}}</span>-->
                    <!--</div>-->
                </div>

                <div v-else>
                    <div v-if="password">
                        <span class="font-weight-grey">Nova lozinka: </span>
                        <span class="font-weight-bold">{{password}}</span>
                    </div>
                    <v-checkbox
                            v-model="checkbox"
                            label="Pošalji na mail?"
                            color="primary"
                    ></v-checkbox>
                    <v-text-field v-if="checkbox" v-model="email" label="Privatni email" outlined></v-text-field>
                </div>


            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="dialog = false" depressed large outlined>Odustani</v-btn>
                <v-btn @click="resetPassword()" color="primary" :loading="loading" :class="loading ? 'disable-events' : ''" depressed large>Spremi promjene</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>

    import {serverBus} from "../../main";

    export default {

        data: function () {
            return {
                show1: false,
                item: null,
                dialog: false,
                checkbox: false,
                loading: false,
                logged_user: null,
                email: '',
                password: '',
                first_name: '',
                last_name: '',
                deleteText: '',
                deleteButton: '',
                dialogTitle: '',
                defaultDeleteText: 'Operacija koju ste zatražali može imati za posljedicu gubitak određenog dijela podataka. Jeste li sigurni da želite izbrisati odabrani resurs?',
                defaultDeleteButton: 'Izbriši',
            }
        },

        created: function () {
            serverBus.$on('show-reset-password-dialog', (table, item, email, first_name, last_name, logged_user, deleteText = null, deleteButton = null, dialogTitle = 'Promjena lozinke') => {
                this.item = item;
                this.first_name = first_name
                this.last_name = last_name
                this.logged_user = logged_user
                // console.log(this.logged_user)
                // if (this.item == 'ucenik'){
                //     this.item = this.$route.params.ucenik_id
                // } else {
                //     this.item = this.$route.params.djelatnik_id
                // }
                this.table = table;
                this.email = email;
                this.deleteText = deleteText ? deleteText : this.defaultDeleteText;
                this.deleteButton = deleteButton ? deleteButton : this.defaultDeleteButton;

                this.dialogTitle = dialogTitle;

                this.dialog = true;
            });

            serverBus.$on('close-delete-item-dialog', () => {
                this.dialog = false;
            })
        },

        methods: {
            resetPassword() {
                this.loading = true
                let passRoute = '/reset'
                let reqBody = {
                    // password: this.password
                }
                if (this.checkbox) {
                    // passRoute = '/reset'
                    reqBody.email = this.email
                }
                if(this.logged_user){
                    passRoute = '/password'
                    reqBody = {
                        password: this.password
                    }
                }
                this.$axios.post('/sso/identity/' + this.item.id + passRoute, reqBody)
                    .then(response => {
                        // console.log(response.data)
                        let user = response.data
                        let email = user.email
                        this.password = user.password
                        serverBus.$emit('show-snackbar', true, 'Lozinka promjenjena!');
                        // this.password = ''
                        // this.loading = false;
                        // this.dialog = false;
                        this.$router.push({
                            name: 'Print',
                            query: {email: email, password: this.password, first_name: this.first_name, last_name: this.last_name},
                            params: {table: 'print', resource_id: this.item.id}
                        });
                        this.password = ''
                    })
                    .catch(function (error) {
                        if (error.response && error.response.status === 422 && error.response.data && error.response.data.message) {
                            serverBus.$emit('show-snackbar', false, error.response.data.message);
                        } else {
                            serverBus.$emit('show-snackbar', false, 'Nešto je pošlo krivo!');
                        }
                    })
                    .finally(() => {

                        this.loading = false;
                    });


                // this.$axios.post(this.optimizeRouteTable() + '/izbrisi/' + this.item.id).finally(() => {
                //     //Reload page samo ako je opci pregled npr(TableView), inace ce router reloadat podatke
                //     var routeTableArrayLength = this.$getTable().split("/").length >= 2
                //     if(!routeTableArrayLength){
                //         serverBus.$emit('reload-all-data');
                //     }
                //     serverBus.$emit('show-snackbar', true, 'Odabrana stavka je izbrisana.');
                //
                //     this.dialog = false;
                //
                //     //Ako je singleItem, izbiris item i vrati se korak u nazad na pregled
                //     if(routeTableArrayLength){
                //         this.$router.go(-1)
                //     }
                // }).catch(function () {
                //     serverBus.$emit('show-snackbar', false, 'Ne mogu izbrisati ovu stavku.');
                // });
            },
        },
    }
</script>

<style>
    .disable-events {
        pointer-events: none
    }
</style>